<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card :class="`${arabic ? 'arFont' : 'enFont'} `">
      <v-card-title>
        <span class="">{{ i18n.start_a_new_purchaseOrder }}</span>
      </v-card-title>
      <v-card-text>
        <v-row wrap>
          <div class="py-1">{{i18n['min_order_quantity']}}: {{ po.min_order_quantity }}</div>
          <v-col cols="12" md="12" class="py-0 px-1" v-for="(field, f) in poForm" :key="'fieldot-'+f">
            <Field :field="field" :item="po" :index="f" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  color="secondary"  text  @click="closeDialog()">{{i18n.cancel}} </v-btn>
        <v-btn  color="success" @click="confirm()">{{i18n.po_submit}} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Field from '@/components/Field.vue';
export default {
  components: {
    Field,
  },
  props:['dialog', 'po'],
  data(){
    return {
      poForm:[
        {
          name: "quantity",
          type: 'number',
          label: 'quantity',
          info: { en: '', ar: '' },
          rules:[
            
          ]
        },
        {
          name: "note",
          type: 'textarea',
          label: 'note',
          info: { en: '', ar: '' },
        },
      ],
    }
  },
  methods:{
    confirm(){
      this.$emit('confirm')
    },
    closeDialog() {
      this.$emit('close')
    }
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
  },
}
</script>

<style>

</style>